export default __webpack_public_path__ + "static/media/dash.53aeb2b4.jpg";